import buildWidget from './build-widget.js';

export default function(section, chart, widgetOptions, populuateCustom = null) {
	section.on('click focus', '#embedModal textarea', function(e) {
		this.select();
		document.execCommand('copy');
	});

	section.on('click', '#printChart', function(e) {
		e.preventDefault();

		window.print();
	});

	const defaultEmbed = $('#embedModal-default');
	const customEmbed = $('#embedModal-custom');

	$('#embedModal').on('show.bs.modal', function(e) {
		defaultEmbed.val(buildWidget(widgetOptions));

		if (populuateCustom) {
			const custom = populuateCustom();

			customEmbed.val(buildWidget({
				... widgetOptions,
				... custom,
				custom,
			}));
		}
	});
};
